import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(name, internalId, enabled, logo) {
  return yield oncallFetch("/api/oncall/administration/partners/add", {
    name,
    internalId,
    enabled,
    logo,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/add.js